import { render } from "./RiskByTags.vue?vue&type=template&id=414fa087"
import script from "./RiskByTags.vue?vue&type=script&lang=js"
export * from "./RiskByTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__